<template>
  <div class="report-container">

    <!-- 主体视界 -->
    <main class="content-main">
      
      <!-- 1. 欢迎语标题（姓名做高级渐变突出） -->
      <section class="welcome-title-group">
        <h1 class="welcome-text">
          Hi ~ <span class="user-name-gradient">{{ ReportData.stuname }}</span> ，<br>
          我们又见面啦 <span class="wave-hand">✨</span>
        </h1>
      </section>

      <!-- 2. 100%保留完整散文文案（错落诗歌排版，拒绝大白框） -->
      <section class="story-body-flow">
        
        <!-- 第一段：时间流逝 -->
        <div class="text-phrase slide-in-1">
          <p class="story-line highlight-time">在忙碌与变化中，</p>
          <p class="story-line">我们依然选择学习。</p>
          <p class="story-line">不是因为被要求，</p>
          <p class="story-line font-bold-teal">而是因为相信成长的力量。</p>
        </div>

        <!-- 第二段：成长蜕变 -->
        <div class="text-phrase pad-left-b slide-in-2">
          <p class="story-line" v-show="ReportData.studate">九月你在富学宝典平台上学习了<span class="font-bold-orange highlight-time">{{ ReportData.studate }}</span>天</p>
          <p v-show="ReportData.playtime" class="story-line">累计学习了<span class="font-bold-orange highlight-time">{{ ReportData.playtime }}</span>小时</p>
          <!-- <p class="story-line">那些你为成长付出的时光，</p>
          <p class="story-line font-bold-orange">正悄悄变成你身上的光。</p>
          <p class="story-line">翻开这一页，收下属于你的</p>
          <p class="story-line strong-dark">半年度成长答卷。</p> -->
        </div>

      </section>

      <!-- 3. 底部动态引导组件 -->
      <section class="footer-guide-section fade-in-up">
        <p class="guide-main-text">第三季度的学习报告已为你生成</p>
        <div class="swipe-hint-box">
          <span class="swipe-finger">👈</span>
          <span class="guide-sub-text">左滑查看更多内容 ~</span>
        </div>
      </section>

    </main>

    <!-- 底部微光朦胧光环装饰 -->
    <!-- <div class="ambient-glow-ball"></div> -->
  </div>
</template>

<script>
export default {
  props: ["ReportData"]
  
}
</script>

<style scoped>
/* 年度报告风格 · 深邃夜空欢迎页 */
.report-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  box-sizing: border-box;
  padding: 35px 28px;
  background:
    url("../../assets/26June/logo.png") right top no-repeat,
    url("../../assets/26September/bg.png") no-repeat center / cover;
  background-size: 100px 32px, cover;
  background-color: #1a0810;
  font-family: -apple-system, "SF Pro Text", "PingFang SC", "Helvetica Neue", sans-serif;
  text-shadow: 0 0 3px rgba(255, 240, 210, 0.5), 0 1px 2px rgba(255, 240, 210, 0.3);
}

.report-container * {
  text-shadow: 0 0 3px rgba(255, 240, 210, 0.5), 0 1px 2px rgba(255, 240, 210, 0.3);
}

/* 主体容器弹性分布 */
.content-main {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 30px 0 10px 0;
  z-index: 2;
}

/* 1. 欢迎标题区 */
.welcome-title-group {
  animation: fadeInDown 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}
.welcome-text {
  font-size: 27px;
  font-weight: 800;
  line-height: 1.55;
  color: #2d1505;
  margin: 0;
  letter-spacing: 1px;
}
/* 名字金色渐变 */
.user-name-gradient {
  color: #4a9eff;
  /* -webkit-background-clip: text; */
  /* background-clip: text; */
  /* -webkit-text-fill-color: transparent; */
  font-weight: 900;
  font-size: 30px;
  /* filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.6)); */
}
.wave-hand {
  display: inline-block;
  animation: wave 2.5s ease-in-out infinite;
  transform-origin: 70% 70%;
}

/* 2. 散文流 */
.story-body-flow {
  display: flex;
  flex-direction: column;
  gap: 34px;
  margin-top: 34px;
}
.text-phrase {
  position: relative;
}
.pad-left-b {
  padding-left: 16px;
}
.story-line {
  font-size: 18px;
  line-height: 1.9;
  margin: 0 0 4px 0;
  color: rgba(45, 20, 5, 0.75);
  letter-spacing: 1px;
}
.story-line:last-child {
  margin-bottom: 0;
}

/* 局部文案高亮 */
.highlight-time {
  color: #4a9eff;
  font-weight: 700;
}
.font-bold-teal {
  color: #4a9eff;
  font-weight: 700;
}
.font-bold-orange {
  display: inline-block;
  /* background: #f3a953; */
  background: rgba(91, 147, 211, 0.35);
  font-weight: 800;
  padding: 2px 12px 2px 8px;
  border-radius: 4px 12px 3px 10px / 10px 3px 12px 4px;
}
.strong-dark {
  color: #2d1505;
  font-weight: 800;
  font-size: 19px;
  letter-spacing: 2px;
}

/* 3. 底部滑动提示 */
.footer-guide-section {
  text-align: center;
  margin-bottom: 10px;
  margin-top: 50px;
}
.guide-main-text {
  font-size: 14px;
  color: rgba(45, 20, 5, 0.85);
  letter-spacing: 1.5px;
  margin: 0 0 10px 0;
}
.swipe-hint-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 9px 20px;
  border-radius: 50px;
  background: rgba(74, 158, 255, 0.1);
  border: 1px solid rgba(74, 158, 255, 0.35);
  box-shadow: 0 0 20px rgba(74, 158, 255, 0.15);
}
.swipe-finger {
  font-size: 15px;
  animation: nudgeLeft 1.5s ease-in-out infinite;
}
.guide-sub-text {
  font-size: 14px;
  font-weight: 700;
  color: #4a9eff;
  letter-spacing: 1px;
}

/* 背景柔光球 */
.ambient-glow-ball {
  position: absolute;
  width: 220px;
  height: 220px;
  right: -70px;
  bottom: 15%;
  background: radial-gradient(circle, rgba(74, 158, 255, 0.18), transparent 70%);
  border-radius: 50%;
  z-index: 1;
  pointer-events: none;
}

/* --- 动画 --- */
@keyframes fadeInDown {
  from { opacity: 0; transform: translateY(-15px); }
  to { opacity: 1; transform: translateY(0); }
}
.slide-in-1 { animation: fadeInBlur 0.8s cubic-bezier(0.16, 1, 0.3, 1) both; }
.slide-in-2 { animation: fadeInBlur 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.2s both; }
.fade-in-up { animation: fadeInUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.4s both; }

@keyframes fadeInBlur {
  from { opacity: 0; transform: translateY(12px); filter: blur(4px); }
  to { opacity: 1; transform: translateY(0); filter: blur(0); }
}
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(15px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes wave {
  0%, 100% { transform: rotate(0deg); }
  10%, 30% { transform: rotate(-12deg); }
  20%, 40% { transform: rotate(14deg); }
  50% { transform: rotate(0deg); }
}

@keyframes nudgeLeft {
  0%, 100% { transform: translateX(0); opacity: 0.9; }
  50% { transform: translateX(-6px); opacity: 0.4; }
}

/* 手机矮屏幕适配 */
@media screen and (max-height: 670px) {
  .welcome-text { font-size: 23px; }
  .user-name-gradient { font-size: 26px; }
  .story-body-flow { gap: 20px; margin-top: 22px; }
  .story-line { font-size: 16px; line-height: 1.75; }
  .strong-dark { font-size: 17px; }
  .guide-main-text { font-size: 13px; }
  .guide-sub-text { font-size: 13px; }
}

/* PC端适配 */
@media screen and (min-width: 786px) {
  .report-container {
    background:
            url("../../assets/26June/logo.png") right top no-repeat,
            url("../../assets/26September/pcbg.png") no-repeat center / cover;
    background-size: 110px 35px, cover;
    width: 100% !important;
    height: 100vh !important;
    padding: 60px 10%;
    border-radius: 0 !important;
    box-shadow: none !important;
    border: none !important;
  }
  .highlight-time {
    font-size: 28px;
    color: #4a9eff;
    font-weight: 700;
  }
  .content-main {
    max-width: 600px;
    margin: 0 auto;
    width: 100%;
    padding: 60px 0;
  }

  .welcome-text {
    font-size: 36px;
  }
  .user-name-gradient {
    font-size: 40px;
  }

  .story-body-flow {
    gap: 44px;
  }
  .story-line {
    font-size: 20px;
    line-height: 2;
  }
  .strong-dark {
    font-size: 22px;
  }

  .guide-main-text {
    font-size: 15px;
  }
  .guide-sub-text {
    font-size: 15px;
  }

  .ambient-glow-ball {
    width: 360px;
    height: 360px;
    right: 6%;
    bottom: 12%;
  }
}
</style>